import HrLayout from "./layouts/HrLayout";
import PhLayout from "./layouts/PhLayout";
import DefaultLayout from "./layouts/DefaultLayout";

import { Login, SSOLogin } from "./pages";
/* Hotel Photography Lead */
import HrFirstLogin from "./pages/hotelRepresentative/HrFirstLogin";
import HrDashboard from "./pages/hotelRepresentative/HrDashboard";
import GetCertified from "./pages/GetCertified";
import HrPhotoshootRequirementForm from "./pages/hotelRepresentative/HrPhotoshootRequirementForm";
import HrManagePhotoshoots from "./pages/hotelRepresentative/HrManagePhotoshoots";
import HrPhotoshootDetails from "./pages/hotelRepresentative/HrPhotoshootDetails";
/* Photographer */
import PhDashboard from "./pages/photographer/PhDashboard";
import PhPhotoshootRequest from "./pages/photographer/PhPhotoshootRequest";
import PhManagePhotoshoots from "./pages/photographer/PhManagePhotoshoots";
import PhPhotoshootDetails from "./pages/photographer/PhPhotoshootDetails";
import PhViewFeedback from "./pages/photographer/PhViewFeedback";
import ChangePassword from "./pages/photographer/ChangePassword";
import ResetPassword from "./pages/photographer/ResetPassword";

import Resources from "./pages/Resources";
import RecceViewer from "./pages/RecceViewer";
import Utils from "./Utils";

// Helper to pick layout based on user type
function getUserLayout() {
  const user = Utils.getUserData && Utils.getUserData();
  if (user?.isHR) return HrLayout;
  if (user?.isPG) return PhLayout;
  return DefaultLayout;
}

const CustomRoutes = [
  {
    path: "/resources",
    secure: false,
    exact: true,
    layout: getUserLayout(),
    component: Resources,
  },
  {
    path: "/sso",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: SSOLogin,
  },
  {
    path: "/",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: Login,
  },
  {
    path: "/reset-password/:token",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: ResetPassword,
  },
  /* Routing for Hotel Photography Lead */
  {
    path: "/hotel-representative-first-login",
    secure: false,
    exact: true,
    layout: DefaultLayout,
    component: HrFirstLogin,
  },
  {
    path: "/hotel-representative-dashboard",
    secure: true,
    exact: true,
    layout: HrLayout,
    component: HrDashboard,
  },
  {
    path: "/get-certified",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: GetCertified,
  },
  {
    path: "/hotel-representative-photoshoot-requirement-form",
    secure: true,
    exact: true,
    layout: HrLayout,
    component: HrPhotoshootRequirementForm,
  },
  {
    path: "/hotel-representative-manage-photoshoots",
    secure: true,
    exact: true,
    layout: HrLayout,
    component: HrManagePhotoshoots,
  },
  {
    path: "/hotel-representative-photoshoot-details/:id",
    secure: true,
    exact: true,
    layout: HrLayout,
    component: HrPhotoshootDetails,
  },
  /* Routing for Photographer */
  {
    path: "/photographer-dashboard",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: PhDashboard,
  },
  {
    path: "/photographer-photoshoot-request/:id",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: PhPhotoshootRequest,
  },
  {
    path: "/photographer-manage-photoshoots",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: PhManagePhotoshoots,
  },
  {
    path: "/photographer-photoshoot-details/:id",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: PhPhotoshootDetails,
  },
  {
    path: "/photoshoot-recce/:pid/:mode/:rfname",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: RecceViewer,
  },
  {
    path: "/photographer-view-feedback/:psid/:origid",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: PhViewFeedback,
  },
  {
    path: "/photographer-view-feedback/:psid/:origid/:fname",
    secure: true,
    exact: true,
    layout: getUserLayout(),
    component: PhViewFeedback,
  },
  {
    path: "/change-password",
    secure: true,
    exact: true,
    layout: PhLayout,
    component: ChangePassword,
  },
];

export default CustomRoutes;
